import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImagesPresenterComponent } from './images-presenter/images-presenter.component';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { TranslateModule } from '@ngx-translate/core';
import { ConfigurationPanelComponent } from './configuration-panel/configuration-panel.component';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { DeadlineTableComponent } from './deadline-table/deadline-table.component';
import { ModalComponent } from './configuration-panel/modal/modal.component';
import { MatRadioModule } from '@angular/material/radio';
import { CarSpecsComponent } from './car-specs/car-specs.component';
import { CarFeaturesComponent } from './car-features/car-features.component';
import { RelatedCarsComponent } from './related-cars/related-cars.component';
import { ModalAlertComponent } from './modal-alert/modal-alert.component';
import { PdfComponent } from './pdf/pdf.component';

import { SwiperModule } from 'swiper/angular';
import { ComponentsModule } from './components.module';
import { CardCarHomeModule } from './card-car-home/card-car-home.module';

import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { ResumeQuoterComponent } from './resume-quoter/resume-quoter.component';
import { DirectivesModule } from '../directives/directives.module';
import { ModalSignatoryComponent } from './modal-signatory/modal-signatory.component';
import { ShareLinkComponent } from './share-link/share-link.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { MsgColorCarComponent } from './msg-color-car/msg-color-car.component';
import { ModalSpecsComponent } from './car-specs/modal-specs/modal-specs.component';
import { TableSpecsComponent } from './car-specs/table-specs/table-specs.component';
import { NgxTippyModule } from 'ngx-tippy-wrapper';
import { CreditDialogComponent } from './credit-dialog/credit-dialog.component';
import { CreditTypeDialogComponent } from './credit-type-dialog/credit-type-dialog.component';
import { ConfigurationPanelCreditComponent } from './configuration-panel-credit/configuration-panel-credit.component';
import { DeadlineTableCreditComponent } from './deadline-table-credit/deadline-table-credit.component';
import { IConfig, NgxMaskModule } from 'ngx-mask';

export const options: Partial<null|IConfig> | (() => Partial<IConfig>) = null;
import { PdfCreditComponent } from './pdf-credit/pdf-credit.component';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
import { ShareLinkCreditComponent } from './share-link-credit/share-link-credit.component';
import { PdfFordComponent } from './pdf-ford/pdf-ford.component';
import { BannerPublicidadComponent } from './banner-publicidad/banner-publicidad.component';

@NgModule({
  declarations: [
    ModalComponent,
    ImagesPresenterComponent,
    ConfigurationPanelComponent,
    DeadlineTableComponent,
    CarSpecsComponent,
    CarFeaturesComponent,
    RelatedCarsComponent,
    ModalAlertComponent,
    ModalSignatoryComponent,
    PdfComponent,
    PdfFordComponent,
    PdfCreditComponent,
    ResumeQuoterComponent,
    ShareLinkComponent,
    LoadingSpinnerComponent,
    MsgColorCarComponent,
    ModalSpecsComponent,
    TableSpecsComponent,
    CreditDialogComponent,
    CreditTypeDialogComponent,
    ConfigurationPanelCreditComponent,
    DeadlineTableCreditComponent,
    ShareLinkCreditComponent,
    BannerPublicidadComponent
  ],
  imports: [
    CommonModule,
    IvyCarouselModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatExpansionModule,
    MatListModule,
    FormsModule,
    MatInputModule,
    MatSliderModule,
    MatTooltipModule,
    ClipboardModule,
    NgxSliderModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatRadioModule,
    SwiperModule,
    TranslateModule.forChild({
      extend: true,
    }),
    MatDialogModule,
    CardCarHomeModule,
    IvyCarouselModule,
    ComponentsModule,
    ShareButtonsModule,
    ShareIconsModule,
    DirectivesModule,
    MatDialogModule,
    NgxTippyModule,
    NgxMaskModule.forRoot(),
    TourMatMenuModule
  ],
  exports: [
    ImagesPresenterComponent,
    ConfigurationPanelComponent,
    DeadlineTableComponent,
    CarSpecsComponent,
    CarFeaturesComponent,
    RelatedCarsComponent,
    ModalAlertComponent,
    ModalSignatoryComponent,
    PdfComponent,
    PdfFordComponent,
    PdfCreditComponent,
    ResumeQuoterComponent,
    ShareLinkComponent,
    LoadingSpinnerComponent,
    MsgColorCarComponent,
    TableSpecsComponent,
    CreditDialogComponent,
    CreditTypeDialogComponent,
    ConfigurationPanelCreditComponent,
    DeadlineTableCreditComponent,
    NgxMaskModule,
    ShareLinkCreditComponent,
    BannerPublicidadComponent
  ],
})
export class QuoterComponentsModule {}
